import { render, staticRenderFns } from "./SalesOrderStatusBuyer.vue?vue&type=template&id=fe6d59fe&"
import script from "./SalesOrderStatusBuyer.vue?vue&type=script&lang=js&"
export * from "./SalesOrderStatusBuyer.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderStatusBuyer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports